import { generatedTypesNew } from '@css-xp/graphtypes';
import { BASE_PATH_WITH_TXA, routeFragments } from './route-paths';

export enum PartnerSearchContext {
  ALL = 'ALL',
  SUBSCRIPTION_ID = 'SUBSCRIPTION_ID',
  INVOICE_ID = 'INVOICE_ID',
  REFUND_ID = 'REFUND_ID',
  ORGANIZATION = 'ORGANIZATION',
  CUSTOMER_ADDRESS = 'CUSTOMER_ADDRESS',
  SITE_URL = 'SITE_URL',
  PERSON = 'PERSON',
}

export const getRouteUrl = (routePath: string, data: { [key: string]: string }) => {
  return Object.keys(data).reduce((acc, key) => acc.replace(`:${key}`, data[key]), routePath);
};

const PathGenerationRules = [
  {
    searchContextsToMatch: [PartnerSearchContext.SUBSCRIPTION_ID, PartnerSearchContext.ALL],
    graphEntitiesToMatch: [generatedTypesNew.GraphEntity.CCP_ENTITLEMENT],
    path: routeFragments.SUBSCRIPTIONS,
  },
  {
    searchContextsToMatch: [PartnerSearchContext.INVOICE_ID, PartnerSearchContext.ALL],
    graphEntitiesToMatch: [generatedTypesNew.GraphEntity.INVOICE],
    path: routeFragments.INVOICES,
  },
  {
    searchContextsToMatch: [PartnerSearchContext.REFUND_ID, PartnerSearchContext.ALL],
    graphEntitiesToMatch: [generatedTypesNew.GraphEntity.REFUND, generatedTypesNew.GraphEntity.CREDITNOTE],
    path: routeFragments.REFUNDS,
  },
  {
    searchContextsToMatch: [PartnerSearchContext.SITE_URL, PartnerSearchContext.ALL],
    graphEntitiesToMatch: [generatedTypesNew.GraphEntity.CLOUD_SITE],
    path: routeFragments.CLOUD_SITE_PATH,
  },
];

const generatePath = (searchContext: string, directMatch: generatedTypesNew.DirectMatch) => {
  const allowedPathGenerationRule = PathGenerationRules.find(
    (pathGenerationRule) =>
      pathGenerationRule.searchContextsToMatch.includes(searchContext as PartnerSearchContext) &&
      pathGenerationRule.graphEntitiesToMatch.includes(directMatch.entity as generatedTypesNew.GraphEntity)
  );
  return allowedPathGenerationRule?.path ?? routeFragments.SEARCH;
};

export const getRouteFromDirectMatchPPC = (
  directMatch: generatedTypesNew.DirectMatch,
  txaId: string,
  searchContext: string
): { pathToRedirectTo: string; isValidDirectMatch: boolean } => {
  const path = generatePath(searchContext, directMatch);
  // directMatch.identifier will never be undefined or null in case a direct match was found
  const encodedIdentifier = encodeURIComponent(directMatch.identifier as string);
  return {
    pathToRedirectTo: `${getRouteUrl(BASE_PATH_WITH_TXA, { txaId })}/${path}/${encodedIdentifier}`,
    isValidDirectMatch: path !== routeFragments.SEARCH,
  };
};
